// extracted by mini-css-extract-plugin
var _1 = "LyA0m";
var _2 = "Q3y2J";
var _3 = "YVdnl";
var _4 = "Ngrtf";
export { _1 as "link", _2 as "link--disabled", _3 as "link--muted", _4 as "link--small" }
